export enum Language {
  English = 0,
  Romanian = 1,
}

export const LanguageNames = new Map<Language, string>([
  [Language.English, 'en-US'],
  [Language.Romanian, 'ro-RO'],
]);

export const DEFAULT_LANGUAGE = LanguageNames.get(Language.English);

export enum TranslationPlatform {
  Angular = 1,
  Mobile = 2,
  Backend = 3,
  Errors = 4,
  NutrientAngular = 5,
  NutrientIos = 6,
  NutrientAndroid = 7,
}
